import React from 'react';
import { useLocation } from 'react-router';
import { useAppDownload } from '~/utils/hooks/useAppDownload';
import { useAiCoachBanner } from '~/utils/hooks/useAiCoachBanner';
import { AppDownloadModal } from './AppDownloadModal';
import { AppDownloadBanner } from './AppDownloadBanner';

const AI_COACH_PAGES = ['/', '/courses', '/profile/my-guides'];

export const AppDownloadManager: React.FC = () => {
  const { pathname } = useLocation();
  const {
    showModal,
    showBanner,
    dismissModal,
    continueInBrowser,
    closeBanner,
    appUrl,
  } = useAppDownload();
  const { shouldShow: isAiCoachModalVisible } = useAiCoachBanner('home');

  const isAiCoachPage =
    pathname === '/' ||
    AI_COACH_PAGES.some((p) => p !== '/' && pathname.startsWith(p));
  const canShowBanner = showBanner && !(isAiCoachPage && isAiCoachModalVisible);

  return (
    <>
      {showModal && (
        <AppDownloadModal
          appUrl={appUrl}
          onDismiss={dismissModal}
          onContinueInBrowser={continueInBrowser}
        />
      )}
      {canShowBanner && (
        <AppDownloadBanner appUrl={appUrl} onClose={closeBanner} />
      )}
    </>
  );
};
